// client/src/utils/leagueLevels.js

export const getActiveLevels = (league) =>
  (league?.league_levels ?? []).filter((level) => level.status === 'active')
